<template>
  <div class="noselect">
    <div v-if="errors.length" style="background-color: #cd1733; color: #fff; text-transform: uppercase; border-radius: 10px; padding: 8px; text-align: center; font-weight: bold; margin-top: 15px;">
      <ul style="margin: 0; padding: 0; list-style: none;">
        <li v-for="error in errors"><i class="fas fa-exclamation-circle"></i> {{ error }}</li>
      </ul>
    </div>

    <div v-if="canResponse">
      <div class="container my-3" style="margin-bottom: 70px !important;">
        <div v-if="!completed">
          <div class="row justify-content-md-center">
            <div v-if="currentStep !== 1" class="col-md-12">
              <ul class="step-progress">
                <li v-bind:class="{ active: currentStep === 2 || currentStep === 3 || currentStep === 4 || currentStep === 5 || currentStep === 6 || currentStep === 7 || currentStep === 8 || currentStep === 9 || currentStep === 10 || currentStep === 11 || currentStep === 12 || currentStep === 13 }">Valoració Elements</li>
                <li v-bind:class="{ active: currentStep === 8 || currentStep === 9 || currentStep === 10 || currentStep === 11 || currentStep === 12 || currentStep === 13 }">Ordenació Elements</li>
                <li v-bind:class="{ active: currentStep === 9 || currentStep === 10 || currentStep === 11 || currentStep === 12 || currentStep === 13 }">Preguntes Obertes</li>
              </ul>
            </div>
            <div v-show="currentStep === 1" class="col-md-9 text-center">
              <img src="@/assets/images/escudo.jpg" class="logo mt-sm-2 pt-2" alt="">
              <h3 class="my-3 fw-bold text-uppercase">Com funciona la consulta?</h3>
              <p class="fw-bold">La consulta consta de 3 grans apartats:</p>
              <div style="background-color: #EFEFEF; padding: 12px; margin-top: 15px; border-radius: 10px; line-height: 24px;">
                <span class="fw-bold">1. Valora els elements</span> de l’escut de l’1 al 10, segons el teu grau de vinculació
              </div>
              <div style="background-color: #EFEFEF; padding: 12px; margin-top: 15px; border-radius: 10px; line-height: 24px;">
                <span class="fw-bold">2. Ordena els elements</span> de més a menys importants segons el teu punt de vista.
              </div>
              <div style="background-color: #EFEFEF; padding: 12px; margin: 15px 0; border-radius: 10px; line-height: 24px;">
                <span class="fw-bold">3. Respon les preguntes</span> que et formulem.
              </div>
              <p class="mt-2" style="line-height: 18px; font-size: 12px;">El club recollirà les respostes de tots els Socis, que servirà com a guia per a dissenyar el nou escut.</p>
            </div>
            <div v-show="currentStep === 2" class="col-md-9 text-center">
              <img src="@/assets/images/senyera.jpg" class="logo" alt="">
              <h3 class="my-3 fw-bold">SENYERA</h3>
              <p class="text-max-800">Bandera de Catalunya. La forma d'escut caironat (rombe recolzat sobre undels seus angles) ve donada per l'escut de la ciutat de Girona.</p>
              <div class="vote">
                <div style="display: flex; justify-content: space-between;">
                  <span style="font-size: 12px;">Molt baixa</span>
                  <span style="font-size: 12px;">Molt alta</span>
                </div>
                <div class="flex-range-div">
                  <img :src="require('@/assets/images/ma_baix.png')" alt="">
                  <el-slider
                    class="w-100"
                    v-model="form.senyera"
                    :step="1"
                    :max="10"
                    :min="1"
                    :marks="rangeMarks"
                    >
                  </el-slider>
                  <img :src="require('@/assets/images/ma_ok.png')" alt="">
                </div>
              </div>
            </div>
            <div v-show="currentStep === 3" class="col-md-9 text-center">
              <img src="@/assets/images/rio.jpg" class="logo" alt="">
              <h3 class="my-3 fw-bold">AIGÜES</h3>
              <p class="text-max-800">Les 'ondes' representen habitualment cossos d'aigua. El nombre d'ondes als diferents escuts (tant de la ciutat com del Girona FC) han variat essent dues, tres o quatre, la representació més habitual.</p>
              <div class="vote">
                <div style="display: flex; justify-content: space-between;">
                  <span style="font-size: 12px;">Molt baixa</span>
                  <span style="font-size: 12px;">Molt alta</span>
                </div>
                <div class="flex-range-div">
                  <img :src="require('@/assets/images/ma_baix.png')" alt="">
                  <el-slider
                    v-model="form.aigues"
                    :step="1"
                    :max="10"
                    :min="1"
                    :marks="rangeMarks"
                    >
                  </el-slider>
                  <img :src="require('@/assets/images/ma_ok.png')" alt="">
                </div>
              </div>
            </div>
            <div v-show="currentStep === 4" class="col-md-9 text-center">
              <img src="@/assets/images/lineas.jpg" class="logo" alt="">
              <h3 class="my-3 fw-bold">LLISTES BLANC-I-VERMELLES</h3>
              <p class="text-max-800">Colors de la primera equipació del club. Es van incloure en l’escut per remarcar els colors que vestien els jugadors de l'equip</p>
              <div class="vote">
                <div style="display: flex; justify-content: space-between;">
                  <span style="font-size: 12px;">Molt baixa</span>
                  <span style="font-size: 12px;">Molt alta</span>
                </div>
                <div class="flex-range-div">
                  <img :src="require('@/assets/images/ma_baix.png')" alt="">
                  <el-slider
                    v-model="form.llistes"
                    :step="1"
                    :max="10"
                    :min="1"
                    :marks="rangeMarks"
                    >
                  </el-slider>
                  <img :src="require('@/assets/images/ma_ok.png')" alt="">
                </div>
              </div>
            </div>
            <div v-show="currentStep === 5" class="col-md-9 text-center">
              <img src="@/assets/images/corona.jpg" class="logo" alt="">
              <h3 class="my-3 fw-bold">CORONA</h3>
              <p class="text-max-800">La corona ve donada per l’escut de la ciutat i representa la seva filiació com a Principat. S'utilitza la corona de tipus ducal doncs aquest era el tipus de corona que timbrava l’escut de la ciutat durant la fundació del club, al 1930.</p>
              <div class="vote">
                <div style="display: flex; justify-content: space-between;">
                  <span style="font-size: 12px;">Molt baixa</span>
                  <span style="font-size: 12px;">Molt alta</span>
                </div>
                <div class="flex-range-div">
                  <img :src="require('@/assets/images/ma_baix.png')" alt="">
                  <el-slider
                    v-model="form.corona"
                    :step="1"
                    :max="10"
                    :min="1"
                    :marks="rangeMarks"
                    >
                  </el-slider>
                  <img :src="require('@/assets/images/ma_ok.png')" alt="">
                </div>
              </div>
            </div>
            <div v-show="currentStep === 6" class="col-md-9 text-center">
              <img src="@/assets/images/nom.jpg" class="logo" alt="">
              <h3 class="my-3 fw-bold">NOM DEL CLUB</h3>
              <p class="text-max-800">Expressió escrita del nom "GIRONA FUTBOL CLUB" que identifica i diferencia l'escut del club respecte els altres. En els darrers anys s'ha reduït la mida de la lletra, fent la seva lectura més dificultosa.</p>
              <div class="vote">
                <div style="display: flex; justify-content: space-between;">
                  <span style="font-size: 12px;">Molt baixa</span>
                  <span style="font-size: 12px;">Molt alta</span>
                </div>
                <div class="flex-range-div">
                  <img :src="require('@/assets/images/ma_baix.png')" alt="">
                  <el-slider
                    v-model="form.nom"
                    :step="1"
                    :max="10"
                    :min="1"
                    :marks="rangeMarks"
                    >
                  </el-slider>
                  <img :src="require('@/assets/images/ma_ok.png')" alt="">
                </div>
              </div>
            </div>
            <div v-show="currentStep === 7" class="col-md-9 text-center">
              <img v-if="form.bordura == null" src="@/assets/images/bordura.jpg" class="logo" alt="">
              <img v-if="form.bordura === 'vermell'" src="@/assets/images/bordura_roja.jpg" class="logo" alt="">
              <img v-if="form.bordura === 'blanc'" src="@/assets/images/bordura_blanca.jpg" class="logo" alt="">
              <h3 class="my-3 fw-bold">COLOR DE LA BORDURA</h3>
              <p class="text-max-800">Circumferència en la que es basa l'escut. En un inici era de color blanc però des de principis de segle es fa servir el vermell com a color destacat.</p>
              <div id="select-color" style="margin: 24px 0;">
                <div style="margin-bottom: 10px;">Sel·leciona bordura</div>
                <input type="radio" v-model="form.bordura" id="vermell" value="1" style="position: absolute; left: -9999px;" />
                <label for="vermell" class="vermell" style="border: 2px solid #EFEFEF; border-radius: 10px;width: 120px; position: relative;">
                  <img src="@/assets/images/bordura_roja_SMALL.jpg" style="width: 74px;" alt="">
                  <div style="padding: 0 12px 0; font-size: 10px;">Vermella</div>
                </label>
                <input type="radio" v-model="form.bordura" id="blanc" value="2" style="position: absolute; left: -9999px;" />
                <label for="blanc" class="blanc" style="border: 2px solid #EFEFEF; border-radius: 10px;width: 120px; position: relative;">
                  <img src="@/assets/images/bordura_blanca_SMALL.jpg" style="width: 74px;" alt="">
                  <div style="padding: 0 12px 0; font-size: 10px;">Blanca</div>
                </label>
              </div>
            </div>
            <div v-show="currentStep === 8" class="col-md-9 text-center">
              <h3 class="my-3 fw-bold mt-5">Ordena de més a menys important els elements</h3>
              <div class="row">
                <div class="col-12 col-md-6 my-4 mx-auto">

                  <div class="row">
                    <div class="col-md-4 my-3" v-for="index in [0,1,2,3,4,5]" :key="index">
                      <img v-if="getOrderImage(index)" :src="getOrderImage(index).img" class="img-fluid" alt=""/>
                      <span @click="unSetItemOrder(index)">

                      </span>
                      <div class="border-order" v-if="typeof getOrderImage(index) === 'undefined'">
                        {{ index + 1 }}
                      </div>
                    </div>
                  </div>

                  <div style="overflow-x: auto; display: flex">
                    <img v-for="(element, elementIndex) in form.ordena" :key="element.id" v-show="element.order == null" @click="setItemOrder(elementIndex, currentOrderStep)" :src="element.img" class="img-fluid mx-1 my-3" alt="" style="max-width: 120px"/>
                  </div>

                  <button class="btn btn-danger btn-sm" v-if="checkOrders().length" @click="resetOrder">
                    Restablir l’ordre
                  </button>

                </div>
              </div>
            </div>
            <div v-show="currentStep === 9" class="col-md-9 text-center">
              <h3 class="my-3 fw-bold mt-5">Afegiries algun element, símbol o referència que creguis que hauria d'aparèixer a l'escut del Girona FC?</h3>
              <textarea name="pregunta1" id="pregunta1" class="form-control mb-3" v-model="form.pregunta1" placeholder="Escriu aquí la teva resposta" cols="20" rows="5"></textarea>
            </div>
            <div v-show="currentStep === 10" class="col-md-9 text-center">
              <h3 class="my-3 fw-bold mt-5">Hi ha algun element que creguis que és prescindible dels que conformen l’escut actual?</h3>
              <textarea name="pregunta2" id="pregunta2" class="form-control mb-3" v-model="form.pregunta2" placeholder="Escriu aquí la teva resposta" cols="20" rows="5"></textarea>
            </div>
            <div v-show="currentStep === 11" class="col-md-9 text-center">
              <h3 class="my-3 fw-bold mt-5">Hi ha alguna consideració que creguis que s'ha de tenir en compte a l'hora dissenyar el nou escut?</h3>
              <textarea name="pregunta3" id="pregunta3" class="form-control mb-3" v-model="form.pregunta3" placeholder="Escriu aquí la teva resposta" cols="20" rows="5"></textarea>
            </div>
            <div v-show="currentStep === 12" class="col-md-9 text-center">
              <h3 class="my-3 fw-bold mt-5">Si t’ha quedat alguna cosa per afegir, pots deixar un comentari a continuació:</h3>
              <textarea name="pregunta4" id="pregunta4" class="form-control mb-3" v-model="form.pregunta4" placeholder="Escriu aquí la teva resposta" cols="20" rows="5"></textarea>
            </div>
            <div v-show="currentStep === 13" class="col-md-9 text-center">
              <h3 class="my-3 fw-bold mt-5">Revisa la teva participació</h3>
              <div style="padding: 12px 8px; border-radius: 10px; margin-bottom: 15px;">
                <p class="text-max-800 fw-bold mb-2">Valoració dels elements</p>
                <div style="display: flex; justify-content: space-between;">Corona: <span>{{ form.corona }}</span></div>
                <div style="display: flex; justify-content: space-between;">Senyera: <span>{{ form.senyera }}</span></div>
                <div style="display: flex; justify-content: space-between;">Llistes blanc-i-vermelles: <span>{{ form.llistes }}</span></div>
                <div style="display: flex; justify-content: space-between;">Aigues: <span>{{ form.aigues }}</span></div>
                <div style="display: flex; justify-content: space-between;">Bordura: <span>{{ form.bordura == 2 ? 'Blanca' : 'Vermella' }}</span></div>
                <div style="display: flex; justify-content: space-between;">Nom del club: <span>{{ form.nom }}</span></div>
              </div>
              <div style="padding: 12px 8px; border-radius: 10px; margin-bottom: 10px;">
                <p class="text-max-800 fw-bold mb-2">Posició d'importància dels elements</p>
                <div style="margin-top: 15px; display: inline-flex; justify-content: center;" v-for="element in getSortedItems()" :key="element.name">
                  <img :src="element.img" style="width: 74px; margin-right: 20px;" alt=""/>
                </div>
              </div>

              <!-- RESUM -->
              <div class="my-4">
                  <p class="text-max-800 fw-bold mb-2 text-center mb-4">Respostes a les preguntes</p>
                    <div style="font-size: 14px;" class="text-left">
                        <p class="mb-0"><b>Afegiries algun element, símbol o referència que creguis que hauria d'aparèixer a l'escut del Girona FC?</b></p>
                        <p>{{ form.pregunta1 }}</p>
                        <hr class="my-1">
                    </div>
                    <div style="font-size: 14px;" class="text-left">
                        <p class="mb-0"><b>Hi ha algun element que creguis que és prescindible dels que conformen l’escut actual?</b></p>
                        <p>{{ form.pregunta2 }}</p>
                        <hr class="my-1">
                    </div>
                    <div style="font-size: 14px;" class="text-left">
                        <p class="mb-0"><b>Hi ha alguna consideració que creguis que s'ha de tenir en compte a l'horari dissenyar el nou escut?</b></p>
                        <p>{{ form.pregunta3 }}</p>
                        <hr class="my-1">
                    </div>
                    <div style="font-size: 14px;" class="text-left">
                        <p class="mb-0"><b>Si t’ha quedat alguna cosa per afegir, pots deixar un comentari a continuació:</b></p>
                        <p>{{ form.pregunta4 }}</p>
                        <hr class="my-1">
                    </div>
              </div>

              <div class="my-4">
                <div style="font-size: 14px;">
                  <input type="checkbox" id="condicions" v-model="form.condicions" value="condicions">
                  <label for="condicions">He llegit i accepto els <a href="/termes-condicions" target="_blank">termes i condicions</a></label>
                </div>
                <div style="font-size: 14px;">
                  <input type="checkbox" id="politica" v-model="form.politica" value="politica">
                  <label for="politica">He llegit i accepto la <a href="https://www.gironafc.cat/politica-de-privacitat" target="_blank">política de privacitat</a></label>
                </div>
              </div>
            </div>
          </div>
          <div class="options">
            <button type="submit" class="next" @click="nextStep" v-if="this.currentStep === 1">COMENÇAR LA CONSULTA</button>
            <button type="submit" class="last" @click="lastStep" v-if="this.currentStep === 3 || this.currentStep === 4 || this.currentStep === 5 || this.currentStep === 6 || this.currentStep === 7 || this.currentStep === 8 || this.currentStep === 9 || this.currentStep === 10 || this.currentStep === 11 || this.currentStep === 12 || this.currentStep === 13">Enrere</button>
            <button type="submit" class="next" @click="nextStep" v-if="this.currentStep === 2 || this.currentStep === 3 || this.currentStep === 4 || this.currentStep === 5 || this.currentStep === 6 || this.currentStep === 7 || this.currentStep === 8 || this.currentStep === 9 || this.currentStep === 10 || this.currentStep === 11 || this.currentStep === 12" :disabled="stepIsDisabled">Següent</button>
            <button type="submit" class="next ml-3" @click="submitForm" v-if="this.currentStep === 13">Enviar participació</button>
          </div>
        </div>
        <div v-else>
          <div class="row justify-content-md-center mt-5">
            <div class="col-md-9 text-center">
              <h3 class="my-2 fw-bold">Gràcies per la teva votació!</h3>
              <img src="@/assets/images/gracias_ 536x354.jpg" class="img-fluid my-3" alt="">
              <p class="text-max-800">El club recollirà les respostes de tots els Socis, que servirà com a guia per a dissenyar el nou escut.</p>
              <p class="text-max-800 mt-2">Comparteix la consulta amb altres Socis!</p>
              <ul class="social">
                <li><a href="https://twitter.com/intent/tweet?text=Ja%20he%20participat%20a%20la%20consulta%20per%20al%20nou%20escut%20del%20Girona%20FC!%20Socis,%20participeu-hi%20ara:%20&url=https://escut.gironafc.cat"><i class="fab fa-twitter"></i></a></li>
                <li><a href="https://www.facebook.com/sharer/sharer.php?u=escut.gironafc.cat"><i class="fab fa-facebook-f"></i></a></li>
                <li><a href="https://www.linkedin.com/shareArticle?mini=true&url=escut.gironafc.cat&title=Ja%20he%20participat%20a%20la%20consulta%20per%20al%20nou%20escut%20del%20Girona%20FC!%20Socis,%20participeu-hi%20ara%3A%20&summary=&source="><i class="fab fa-linkedin-in"></i></a></li>
                <li><a href="https://api.whatsapp.com/send?text=Ja%20he%20participat%20a%20la%20consulta%20per%20al%20nou%20escut%20del%20Girona%20FC!%20Socis,%20participeu-hi%20ara:%20https://escut.gironafc.cat"><i class="fab fa-whatsapp"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import _ from 'lodash'

export default {
  components: {

  },
  head () {
    return {
      title: 'Consulta - Girona FC',
      meta: [
        { hid: 'description', name: 'description', content: 'Consulta per a la renovació de l\'escut del Girona FC' },
        { hid: 'robots', name: 'robots', content: 'noindex' }
      ]
    }
  },
  data: () => {
    return {
      currentStep: 1,
      dragging: false,
      steps: [
        {
          id: 1,
          title: "COM FUNCIONA LA CONSULTA",
        },
        {
          id: 2,
          title: "SENYERA",
        },
        {
          id: 3,
          title: "AIGÜES",
        },
        {
          id: 4,
          title: "LLISTES BLANC-I-VERMELLES",
        },
        {
          id: 5,
          title: "CORONA",
        },
        {
          id: 6,
          title: "NOM DEL CLUB",
        },
        {
          id: 7,
          title: "BORDURA",
        },
        {
          id: 8,
          title: "ORDENA",
        },
        {
          id: 9,
          title: "PREGUNTA 1",
        },
        {
          id: 10,
          title: "PREGUNTA 2",
        },
        {
          id: 11,
          title: "PREGUNTA 3",
        },
        {
          id: 12,
          title: "PREGUNTA 4",
        },
        {
          id: 13,
          title: "GRACIES",
        }
      ],
      errors: [],
      completed: false,
      form: {
        corona: 5,
        senyera: 5,
        llistes: 5,
        aigues: 5,
        nom: 5,
        bordura: null,
        condicions: false,
        politica: false,
        pregunta1: "",
        pregunta2: "",
        pregunta3: "",
        pregunta4: "",
        orderSelecteds: {

        },
        ordena: [
          {
            name: "SENYERA",
            id: 1,
            img: require('@/assets/images/senyera_small.jpg'),
            order: null,
          },
          {
            name: "AIGÜES",
            id: 2,
            img: require('@/assets/images/aigues_small.jpg'),
            order: null,
          },
          {
            name: "LLISTES BLANC-I-VERMELLES",
            id: 3,
            img: require('@/assets/images/llistes_small.jpg'),
            order: null,
          },
          {
            name: "CORONA",
            id: 4,
            img: require('@/assets/images/corona_small.jpg'),
            order: null,
          },
          {
            name: "NOM DEL CLUB",
            id: 5,
            img: require('@/assets/images/nom_small.jpg'),
            order: null,
          },
          {
            name: "BORDURA",
            id: 6,
            img: require('@/assets/images/bordura_small.jpg'),
            order: null,
          },
        ],
      },
      currentOrderStep: 0,
      rangeMarks: {
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        6: '6',
        7: '7',
        8: '8',
        9: '9',
        10: '10',
      },
      canResponse: false,
      errorMessage: "",
    }
  },
  computed: {
    orderIsDisabled() {
      if (this.form.ordena_corona !== 1) {
        return true;
      }
    },
    stepIsDisabled: function(){
      if(this.currentStep === 5) {
        if (this.form.corona == null) {
          return true;
        }
      }
      if(this.currentStep === 2) {
        if (this.form.senyera == null) {
          return true;
        }
      }
      if(this.currentStep === 4) {
        if (this.form.llistes == null) {
          return true;
        }
      }
      if(this.currentStep === 3) {
        if (this.form.aigues == null) {
          return true;
        }
      }
      if(this.currentStep === 7) {
        if (this.form.bordura == null) {
          return true;
        }
      }
      if(this.currentStep === 6) {
        if (this.form.nom == null) {
          return true;
        }
      }
      if(this.currentStep === 8) {
        return this.checkOrders().length != 6
      }
    }
  },
  methods: {
    checkMove: function(e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
    nextStep: function (e) {

      this.errors = [];

      if(this.currentStep === 5) {
        if (this.form.corona == null) {
          this.errors.push('Per avançar en la consulta, primer introdueix la teva votació.');
          return false;
        }
      }

      if(this.currentStep === 2) {
        if (this.form.senyera == null) {
          this.errors.push('Per avançar en la consulta, primer introdueix la teva votació.');
          return false;
        }
      }

      if(this.currentStep === 4) {
        if (this.form.llistes == null) {
          this.errors.push('Per avançar en la consulta, primer introdueix la teva votació.');
          return false;
        }
      }

      if(this.currentStep === 3) {
        if (this.form.aigues == null) {
          this.errors.push('Per avançar en la consulta, primer introdueix la teva votació.');
          return false;
        }
      }

      if(this.currentStep === 7) {
        if (this.form.bordura == null) {
          this.errors.push('Per avançar en la consulta, primer introdueix la teva votació.');
          return false;
        }
      }

      if(this.currentStep === 6) {
        if (this.form.nom == null) {
          this.errors.push('Per avançar en la consulta, primer introdueix la teva votació.');
          return false;
        }
      }

      /*if(this.currentStep === 8) {
          if (this.form.ordena_corona == null || this.form.ordena_aigues == null || this.form.ordena_nom == null || this.form.ordena_bordura == null || this.form.ordena_llistes == null || this.form.ordena_senyera == null) {
              this.errors.push('Per avançar en la consulta, primer introdueix la teva votació.');
              return false;
          }
      }*/

      this.currentStep++;

      e.preventDefault();
    },
    lastStep() {
      this.currentStep--;
    },
    submitForm: function(e) {

      this.errors = [];
      let instance = this

      if(this.currentStep === 13) {
        if (this.form.condicions === false || this.form.politica === false ) {
          this.errors.push('Per enviar la consulta has de acceptar els termes i condicions i la política de privacitat.');
          return false;
        }
      }

      let loader = this.$loading.show();

      let jsonDataApi = {
        "arrayValueElement": [
          {
            "idElement": 1, // 1 SENYERA
            "value": this.form.senyera
          },
          {
            "idElement": 2, // 2 AIGÜES
            "value": this.form.aigues
          },
          {
            "idElement": 3, // 3 LLISTES BLANC-I-VERMELLES
            "value": this.form.llistes
          },
          {
            "idElement": 4, // 4 CORONA
            "value": this.form.corona
          },
          {
            "idElement": 5, // 5 NOM DEL CLUB
            "value": this.form.nom
          },
          {
            "idElement": 6, // 6 COLOR DE LA BORDURA
            "value": this.form.bordura
          }
        ],
        "arraySortElement": [
          {
            "idElement": 1,
            "pos": this.form.ordena[0].order + 1
          },
          {
            "idElement": 2,
            "pos": this.form.ordena[1].order + 1
          },
          {
            "idElement": 3,
            "pos": this.form.ordena[2].order + 1
          },
          {
            "idElement": 4,
            "pos": this.form.ordena[3].order + 1
          },
          {
            "idElement": 5,
            "pos": this.form.ordena[4].order + 1
          },
          {
            "idElement": 6,
            "pos": this.form.ordena[5].order + 1
          }
        ],
        "arrayQuestion": [
          {
            "idQuestion": 1,
            "response": this.form.pregunta1
          },
          {
            "idQuestion": 2,
            "response": this.form.pregunta2
          },
          {
            "idQuestion": 3,
            "response": this.form.pregunta3
          },
          {
            "idQuestion": 4,
            "response": this.form.pregunta4
          }
        ]
      }

      // this.$http.post("https://app.gironafcapp.com/apiclient/scripts/api/api.php?format=json&key=54d8e18ba6e4265135cb439484c7f2f8&req=escut_setResponse&idSocio=" + this.$cookies.get('member_number') + "&idPromocion=29", jsonDataApi).then((response) => {
      //   if(response.data.result == 'error') {
      //     instance.errors.push(response.data.message)
      //   } else if(response.data.result == 'success') {
      //     this.completed = true;
      //   }

      //   loader.hide()

      // })
        this.completed = true;
        loader.hide()
      e.preventDefault();
    },
    getOrderImage(index) {
      var item = _.find(this.form.ordena, o => {
          return o.order === index
        })

      return item
    },
    setItemOrder(elementIndex, order) {
      this.form.ordena[elementIndex].order = this.currentOrderStep++
    },
    unSetItemOrder(elementIndex) {
      this.form.ordena[elementIndex].order = null
    },
    /** Check which elements are ordered */
    checkOrders() {
      return _.filter(this.form.ordena, o => o.order != null)
    },
    resetOrder() {
      this.form.ordena.forEach(element => {
        element.order = null
      })

      this.currentOrderStep = 0
    },
    getSortedItems() {
      return _.sortBy(this.form.ordena, 'order')
    },
  },
  mounted() {
    // let member_number = this.$cookies.get("member_number");
    // let instance = this

    // if(!member_number) {
    //   window.location.href = '/login'
    //   return false
    // }

    this.canResponse = true


    // this.$http.get("https://app.gironafcapp.com/apiclient/scripts/api/api.php?format=json&key=54d8e18ba6e4265135cb439484c7f2f8&req=escut_canResponse&idSocio=" + member_number + "&idPromocion=29").then((response) => {
    //   instance.canResponse = response.data.canResponse

    //   if(!instance.canResponse) {
    //     this.errors.push(response.data.message)
    //   }

    //   instance.errorMessage = response.data.message
    // })
  }
}
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
